import React, {Component} from "react";
import { NavbarToggler } from "reactstrap";
import { connect } from "react-redux";
import { logout } from "../../actions/actionLogin";
import {Link} from "react-router-dom";

class Header extends Component {

    constructor(props) {
        super(props);
    }

    sidebarMinimize(e) {
        e.preventDefault();
        document.body.classList.toggle("sidebar-minimized");
    }

    mobileSidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle("sidebar-mobile-show");
    }

    asideToggle(e) {
        e.preventDefault();
        e.target.classList.add("fa-angle-left");
        document.body.classList.toggle("aside-menu-hidden");
    }

    render() {
        let header_logo = window.localStorage.getItem('header_logo');
        header_logo = header_logo ? header_logo : "img/headerlogo.png";

        let elem = document.getElementById("favicon");
        let favicon_logo = window.localStorage.getItem('favicon_logo');
        if (favicon_logo != undefined){
            elem.href=favicon_logo;
        }

        let html_title = window.localStorage.getItem('html_title');
        if (html_title != undefined){
             document.title=html_title;
        }

        return (
            <header className="app-header navbar">
                <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>
                    <span className="navbar-toggler-icon"></span>
                </NavbarToggler>
                <Link to={"/"}><img className= "header_logo" src={header_logo} width="122" height="35" alt="logo"/></Link>
                <div className="flex_block">
                </div>
            </header> 
        );
    }
}


function mapStateToProps() { 
    return {
    
    };
}

function mapDispatchToProps(dispatch) {
    return({
        logout: (logout_data) => {dispatch(logout(logout_data));}
    });
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Header);


// WEBPACK FOOTER //
// ./src/components/Header/Header.js